import React, { useState, useEffect, useContext, useRef } from 'react';
import DatePicker from "react-datepicker";
import LoadingSpinnerImage from "../Shared/LoadingSpinnerImage.js";
import * as FieldTypes from '../Shared/FieldTypes/FieldTypes.js'
import * as Constants from '../Shared/Constants.js'
import CommentsList from '../Shared/CommentsList/CommentsList.js'
import MedboardPdf from '../MedboardPdf/MedboardPdf.jsx';
import { Tags } from '../Shared/Tags.js'
import TaskManager from '../TaskManager/TaskManager.js';
import { EventEmitter } from "events";
import EntityAssociation from "../Shared/EntityAssociation.js";

const ItemDetailsPane = ({ globalContext }) => {

    const AppContext = globalContext;


    return (
        <div
            style={{ height: "100vh", overflow: "auto" }}
            className={`slide-pane ${AppContext.isPaneOpen ? "open" : ""}`}
        >
            <div className="content">

                <div style={{ flex: "1" }}>

                    {(AppContext.currentItem === null || AppContext.isLoadingItemDetails) ? (
                        <>
                            <div>
                                <LoadingSpinnerImage />
                            </div>
                        </>
                    ) : (
                        <>
                            <div style={{ textAlign: "right", marginBottom: "10px" }}>
                                <button className="close-button" onClick={AppContext.closePane}>
                                    <i className="fas fa-times"></i>
                                </button>
                            </div>

                            <h2>{AppContext.singleItemTitle} Details</h2>

                            {/* FORMS FIELDS */}

                            <div style={{ margin: "40px 0px" }}>



                                {/* Form field: Title */}

                                <div className="view-task-field">
                                    <div className="view-task-field-line">
                                        <div className="view-task-field-title">Filename</div>
                                        <div className="view-task-field-value">
                                            <span className={`task-name editable-field-span`} >
                                                {AppContext.currentItem.Filename}
                                            </span>
                                        </div>
                                    </div>
                                </div>



                                {/* Form field: Certificate/Operator */}

                                <div className="view-task-field">
                                    <div className="view-task-field-line">
                                        <div className="view-task-field-title">EntityType</div>
                                        <div className="view-task-field-value">
                                            <span className={`task-name editable-field-span`} >
                                                {AppContext.currentItem.EntityType}
                                            </span>
                                        </div>
                                    </div>
                                </div>





                            </div>

                        </>
                    )}

                </div>

            </div>
        </div>
    );
};














export default ItemDetailsPane;